<template>
    <div class="termine-view">
        <!-- Header -->
        <HeaderComponent />

        <!-- Termine Navigation Bar -->
        <nav class="termine-navigation">
            <div class="container">
                <div class="d-flex justify-content-start align-items-center">
                    <button @click="goBack" class="btn-back">
                        &lt; zurück
                    </button>
                </div>
            </div>
        </nav>

        <!-- Hero Image -->
        <div class="termine-hero">
            <img src="/images/braunZiele.jpg" alt="Bruchköbel" class="hero-image">
        </div>

        <!-- Termine Content -->
        <main class="termine-content">
            <div class="container">
                <div class="termine-main-layout">
                    <!-- Left side: Termine intro text -->
                    <div class="termine-left">
                        <h1 class="termine-title">Termine</h1>
                        <p class="termine-subtitle">Ganz persönlich</p>
                        <div class="termine-text">
                            <p>
                                <strong>Bike and Talk</strong><br>
                                Zusammen mit dem Rad unsere schöne Stadt erkunden und Informationen zu unterschiedlichen
                                Projekten und Themen bekommen.
                            </p>
                            <p>
                                <strong>Stadtspaziergang</strong><br>
                                Wir erkunden zu Fuß die Innenstadt mit Informationen zu abgeschlossenen und geplanten Projekten
                                für unsere Stadt.
                            </p>
                            <p>
                                <strong>Infostände - Mit Tee, Gebäck und Gespräch</strong><br>
                                Der Klassiker im Wahlkampf neu gedacht. Ein warmes Getränk, leckeres Gebäck vom lokalen Bäcker
                                – dabei redet es sich leichter. Nur Reden geht natürlich auch. Infomaterial gibt es selbstverständlich
                                auch.
                            </p>
                        </div>
                    </div>

                    <!-- Right side: Termine grid -->
                    <div class="termine-right">
                        <div class="termine-grid">
                            <div v-for="termin in allTermine" :key="termin.id" class="termin-card" :data-termin-id="termin.id">
                                <div class="termin-header" @click="toggleTermin(termin.id)">
                                    <h3 class="termin-title">{{ termin.title }}</h3>
                                </div>

                                <div v-if="expandedTermine.includes(termin.id)" class="termin-content">
                                    <div v-if="termin.content" class="termin-details">
                                        <p v-for="line in termin.content.split('\n')" :key="line" v-html="line"></p>
                                    </div>

                                    <!-- Termin Actions: Close -->
                                    <div class="termin-actions">
                                        <button @click="toggleTermin(termin.id)" class="btn-termin-close">
                                            schließen
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        <!-- Footer -->
        <FooterComponent />
    </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
    name: 'TermineView',
    components: {
        HeaderComponent,
        FooterComponent
    },
    data() {
        return {
            expandedTermine: [],
            allTermine: [
                {
                    id: 1,
                    title: 'Sonntag, 28.09.25, 10-12 Uhr - Bike and Talk',
                    content: 'Treffpunkt: Altes Rathaus Roßdorf\nStrecke: Butterstadt, Niederissgheim, Oberissigehim\nEnde in Oberissigheim auf der Kerb mit Möglichkeit zum Schnitzelessen'
                },
                {
                    id: 2,
                    title: 'Freitag, 03.10.25, 11 – 13 Uhr - Bike and Talk',
                    content: 'Treffpunkt: Stadthaus\nStrecke: Niederried, Kirlesiedlung, Peller, Landwehr\nEnde am Weberhof mit Gelegenheit zur Einkehr'
                },
                {
                    id: 3,
                    title: 'Donnerstag, 02.10.25 um 18 Uhr - Stadtspaziergang',
                    content: 'Treffpunk: Stadtplatz\nAbschluss im Stadtladen „Lokal" bei einem Getränk'
                },
                {
                    id: 4,
                    title: 'Freitag, 10.10.25, 08- 12 Uhr - Infostand Wochenmarkt Bruchköbel',
                    content: ''
                },
                {
                    id: 5,
                    title: 'Donnerstag, 16.10. 06:30 – 08:00 Uhr - Infostand Bahnhof Bruchköbel',
                    content: ''
                },
                {
                    id: 6,
                    title: 'Samstag 18.10.25 – 09 - 12 Uhr - Infostand Rewe Stadthaus',
                    content: ''
                },
                {
                    id: 7,
                    title: 'Samstag 25.10.25 – 11 – 14 Uhr - Infostand Rewe Stadthaus',
                    content: ''
                }
            ]
        }
    },
    methods: {
        goBack() {
            this.$router.push('/')
        },
        toggleTermin(terminId) {
            const index = this.expandedTermine.indexOf(terminId)
            if (index > -1) {
                // If clicking on an already open accordion, close it
                this.expandedTermine.splice(index, 1)
            } else {
                // If opening a new accordion, close all others first
                this.expandedTermine = [terminId]
            }
        }
    }
}
</script>